import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import { Picker,List} from 'antd-mobile/lib';
import arrayTreeFilter from 'array-tree-filter';
import Util from '../../../util'
import '../investPlan/InvestmentPlan.css'
import './Pay.css'
import {protocolCode,bankCode } from '../../../BankCode'
import { getTradeInfo ,getSuperFundTradeLimit,syncCwimRiskToCamcAndStopOutOfRiskBuyPlan,syncCwimToCamcNew,hasOtsRiskRearing} from '../../../action/productAction';
import NavigatorMain from '../../NavigatorMain';
import { getInvestmentDetial,createBuyPlanzxk,createBuyPlan,createPlan,dttByMoneyFundValidate,dttByMoneyFundSubmit} from '../../../action/myAssets/InvestPlanAction.js';
import PayWarmTips from './PayWarmTips';
import {
  getCurrentAdjustDetail,
  smSzt
} from '../../../action/investmentAction';
import { myPaymentTextDT } from '../../../action/publicAction';
import PayCardSuperFund from './PayCardSuperFund'
import {ModalTips} from '../../fundDetail/AlerModle';
import ModalPaySup from '../../Modal/ModalPaySup';
import { goPubQuestionnaires } from "../../../getPay"
import { getUserInfoList } from "../../../action/loginAction"
import { findCamcHqtExist } from '../../../action/myAssets/userInfoAction'
const CustomChildren = props => (
  <div
    onClick={props.onClick}
    className='text-bar'
    style={{height: 52}}
  >
      <p style={{paddingLeft: 20, fontSize: 16, color: "#333", fontWeight: "500"}}>{props.children}</p>
      <p><span style={{color: "#999", fontSize: 14}}>{props.extra}</span><img style={{height:10,width:10}} src={require('../../../imgs/pay_you_allow.png')} /></p>
  </div>
);
var accountTip;
var account;
class FixedInvestmentSuperFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickerValue:[0,1],
      agreeIndex:0,
      amount:'',
      dayIncomeDate:'',
      ThreeIncome:'',
      dataSouse:[
        {
          label: '每月',
          value: 0,
          key:0,
          children:[
            {label:'1日',value:1,key:0},
            {label:'2日',value:2,key:1},
            {label:'3日',value:3,key:2},
            {label:'4日',value:4,key:3},
            {label:'5日',value:5,key:4},
            {label:'6日',value:6,key:5},
            {label:'7日',value:7,key:6},
            {label:'8日',value:8,key:7},
            {label:'9日',value:9,key:8},
            {label:'10日',value:10,key:9},
            {label:'11日',value:11,key:10},
            {label:'12日',value:12,key:11},
            {label:'13日',value:13,key:12},
            {label:'14日',value:14,key:13},
            {label:'15日',value:15,key:14},
            {label:'16日',value:16,key:15},
            {label:'17日',value:17,key:16},
            {label:'18日',value:18,key:17},
            {label:'19日',value:19,key:18},
            {label:'20日',value:20,key:19},
            {label:'21日',value:21,key:20},
            {label:'22日',value:22,key:21},
            {label:'23日',value:23,key:22},
            {label:'24日',value:24,key:23},
            {label:'25日',value:25,key:24},
            {label:'26日',value:26,key:25},
            {label:'27日',value:27,key:26},
            {label:'28日',value:28,key:27}
          ]
        }
      ],
      tipByMax: "",
      amountMax:'0',
      popoverCount: '', //气泡金额数位文本
      popoverCountFlag: false, //数位显示标志
      showRiskModal: false,
      unionPayTransformBool: false
    };
  }
  componentWillMount(){
    document.title= "新建定投计划";
    let {payInfoData,dispatch}=this.props;
    let {fundCode,productType}=this.props;
    let dataAmount={
        businessType:'T022',
        superFundCode:fundCode,
    }
    if (this.props.text) 
    this.props.dispatch(myPaymentTextDT(this.props.text-0>500?this.props.text:'500'));
    if (payInfoData.currentType==4) {
      this.props.dispatch(getTradeInfo(fundCode,'T522',productType,(result,i,type)=>{
        this.props.dispatch(getSuperFundTradeLimit(dataAmount,(val)=>{
          this.setState({amount:val.content.minLimit,amountMax:val.content.maxLimit})
          this.maxTipFun(this.props.paymentText, i, type, val.content.minLimit, val.content.maxLimit);
        }));
        Object.assign(result,{currentType:type},{currentIndex:i})
        dispatch({
          type:"SUPER_FUND_DT_PAY_INFO",
          text:result
        });
      }))
    }else {
      this.props.dispatch(getSuperFundTradeLimit(dataAmount,(val)=>{
        this.setState({amount:val.content.minLimit,amountMax:val.content.maxLimit})
        this.maxTipFun(this.props.paymentText, this.props.payInfoData.currentIndex, this.props.payInfoData.currentType, val.content.minLimit, val.content.maxLimit);
      }));
    }
    let inData = {
      superFundCode:fundCode,
      periodType:0
    }
    this.props.dispatch(getUserInfoList((result) => {
      const inParamsData = {
        certNo: result.content.certNo,
        certType: result.content.certType,
        name: result.content.name
      }
      this.props.dispatch(findCamcHqtExist(inParamsData))
    }));
  }
  popoverCountFun = (text) => {
    if(text>=10000 && text<100000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'万'
      })
    }else if(text>=100000 && text<1000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'十万'
      })
    }else if(text>=1000000 && text<10000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'百万'
      })
    }else if(text>=10000000 && text<100000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'千万'
      })
    }else if(text>=100000000 && text<1000000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'亿'
      })
    }else if(text>=1000000000 && text<10000000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'十亿'
      })
    }else{
      this.setState({
        popoverCountFlag:false,
        popoverCount:''
      })
    }
  }
  componentDidMount(){
    this.props.parThis.getChildThis(this);
    this.popoverCountFun(this.props.paymentText);
  }
  onChangeText(text){
    this.props.dispatch(myPaymentTextDT(text))
    this.popoverCountFun(text);
    this.maxTipFun(text, this.props.payInfoData.currentIndex, this.props.payInfoData.currentType, this.state.amount, this.state.amountMax);
  }
  ProtocolPaper(name){
    let code=protocolCode[name];
    hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
    })
  }
  isAgreeClick(){
    let { agreeIndex } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
      this.props.dispatch(smSzt(1))
    } else {
      this.setState({
        agreeIndex:0,
      })
      this.props.dispatch(smSzt(0))
    }
  }
  next(res){
    const { 
      payInfoData,
      paymentText,
      dispatch
    }=this.props;
    let {amount}=this.state;
    if(this.state.tipByMax) {
      Toast.info( this.state.tipByMax, Util.ToastTime );
      return;
    }
    if (amount>paymentText) {
      Toast.info( '投资金额不可低于'+amount+'元', Util.ToastTime );
      return;
    }
    if (payInfoData.currentType==1) {
      let item=payInfoData.content.yhkNewListList[payInfoData.currentIndex];
      if (!item) {
        Toast.info( '请选择支付方式', Util.ToastTime );
        return;
      } 
      if (!item.disable) {
        Toast.info( '请选择支付方式', Util.ToastTime );
        return;
      }
      if(paymentText>5000 && !payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool){
        this.setState({unionPayTransformBool: true})
        return;
      }
      if (item.tradeMaxAmountTips.split('|')[0]-0<paymentText) {
        Toast.info( item.tradeMaxAmountTips.split('|')[1], Util.ToastTime );
        return false;
      } 
    } else if(payInfoData.currentType==2) {
      let item=payInfoData.content.shareList[payInfoData.currentIndex];
      if (!item) {
        Toast.info( '请选择支付方式', Util.ToastTime );
        return;
      } 
      if (!item.disable) {
        Toast.info( '请选择支付方式', Util.ToastTime );
        return;
      }
    } else if(payInfoData.currentType==3) {
      let item=payInfoData.content.currencyFund[payInfoData.currentIndex];
      if (!item) {
        Toast.info( '请选择支付方式', Util.ToastTime );
        return;
      } 
      
    }

    if(payInfoData.currentType==1 && payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool){
      const findHqtExist = this.props.findHqtExist;
      let params = {
        otsTradeAccountNo:findHqtExist.tradeAccountNo,
        raiseMethod:"9"
      }
      if(res == "1") {
        try{
          dispatch(syncCwimToCamcNew({}, (_flag) => {
            if(_flag) {
              console.log('bbb')
              //组合成分基金中包含华夏基金产品，需弹窗提示
              this.props.dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
          
                let data = result[result.length - 1].itemAdjustList;
                let fundsArr = [];
                console.log(data);
                for (let i = 0; i< data.length; i++) {
                      if(data[i].fundName.indexOf('华夏')!= -1){
                        fundsArr.push(data[i].fundName)
                        }
                    }
                    if (fundsArr.length == 0) {
                      console.log(1)
                      this.props.parThis.setState({
                     pwdFlag:true
                      })
                    } else {
                      console.log(2)
                      this.props.parThis.setState({
                        data:fundsArr.join('、'),
                        isShowModal2:true
                      })  
                    }
              }))
            }else {
              this.riskShowFun();
            }
          }))
        }catch(err){
            Toast.hide();
        }
      }else if(res == "2") {
        try{
          console.log('bbb')
          //组合成分基金中包含华夏基金产品，需弹窗提示
          this.props.dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
      
            let data = result[result.length - 1].itemAdjustList;
            let fundsArr = [];
            console.log(data);
            for (let i = 0; i< data.length; i++) {
                  if(data[i].fundName.indexOf('华夏')!= -1){
                    fundsArr.push(data[i].fundName)
                    }
                }
                if (fundsArr.length == 0) {
                  console.log(1)
                  this.props.parThis.setState({
                 pwdFlag:true
                  })
                } else {
                  console.log(2)
                  this.props.parThis.setState({
                    data:fundsArr.join('、'),
                    isShowModal2:true
                  })  
                }
          }))
        }catch(err){
            Toast.hide();
        }
      }else {
        try{
            dispatch(hasOtsRiskRearing(params,(c1,c2,z1)=>{
              console.log(c1,c2,z1,"是否同步问卷")
              if(z1){
                console.log('bbb')
                //组合成分基金中包含华夏基金产品，需弹窗提示
                this.props.dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
            
                  let data = result[result.length - 1].itemAdjustList;
                  let fundsArr = [];
                  console.log(data);
                  for (let i = 0; i< data.length; i++) {
                        if(data[i].fundName.indexOf('华夏')!= -1){
                          fundsArr.push(data[i].fundName)
                          }
                      }
                      if (fundsArr.length == 0) {
                        console.log(1)
                        this.props.parThis.setState({
                       pwdFlag:true
                        })
                      } else {
                        console.log(2)
                        this.props.parThis.setState({
                          data:fundsArr.join('、'),
                          isShowModal2:true
                        })  
                      }
                }))
              }else{
                if(c1 === c2){
                    console.log(c1,c2,z1,"c1 === c2同步问卷")
                    dispatch(syncCwimToCamcNew({}, (_flag) => {
                      if(_flag) {
                        console.log('bbb')
                        //组合成分基金中包含华夏基金产品，需弹窗提示
                        this.props.dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                    
                          let data = result[result.length - 1].itemAdjustList;
                          let fundsArr = [];
                          console.log(data);
                          for (let i = 0; i< data.length; i++) {
                                if(data[i].fundName.indexOf('华夏')!= -1){
                                  fundsArr.push(data[i].fundName)
                                  }
                              }
                              if (fundsArr.length == 0) {
                                console.log(1)
                                this.props.parThis.setState({
                               pwdFlag:true
                                })
                              } else {
                                console.log(2)
                                this.props.parThis.setState({
                                  data:fundsArr.join('、'),
                                  isShowModal2:true
                                })  
                              }
                        }))
                      }else {
                        this.riskShowFun();
                      }
                    }))
                }else{
                  console.log(c1,c2,z1,"c1 === c2同步问卷")
                  goPubQuestionnaires(hashHistory, window.history.length, ()=>{
                    dispatch(syncCwimToCamcNew({}, (_flag) => {
                      if(_flag) {
                        console.log('bbb')
                        //组合成分基金中包含华夏基金产品，需弹窗提示
                        this.props.dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                    
                          let data = result[result.length - 1].itemAdjustList;
                          let fundsArr = [];
                          console.log(data);
                          for (let i = 0; i< data.length; i++) {
                                if(data[i].fundName.indexOf('华夏')!= -1){
                                  fundsArr.push(data[i].fundName)
                                  }
                              }
                              if (fundsArr.length == 0) {
                                console.log(1)
                                this.props.parThis.setState({
                               pwdFlag:true
                                })
                              } else {
                                console.log(2)
                                this.props.parThis.setState({
                                  data:fundsArr.join('、'),
                                  isShowModal2:true
                                })  
                              }
                        }))
                      }else {
                        this.riskShowFun();
                      }
                    }))
                  })
                }
              }
            }))
        }catch(err){
            Toast.hide();
            console.log(err,'同步问卷失败')
        }
      }
    }else{
      //组合成分基金中包含华夏基金产品，需弹窗提示
      this.props.dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                  
        let data = result[result.length - 1].itemAdjustList;
        let fundsArr = [];
        console.log(data);
        for (let i = 0; i< data.length; i++) {
              if(data[i].fundName.indexOf('华夏')!= -1){
                fundsArr.push(data[i].fundName)
                }
            }
            if (fundsArr.length == 0) {
              console.log(1)
              this.props.parThis.setState({
            pwdFlag:true
              })
            } else {
              console.log(2)
              this.props.parThis.setState({
                data:fundsArr.join('、'),
                isShowModal2:true
              })  
            }
      }))
    }
  }
  keyOk = () => {
    const { 
      payInfoData,
      dispatch
    }=this.props;
    let {planItem,fundCode,fundName}=this.props;
    const pushResult=(i,result)=>{
      if (i===1) {
          Toast.hide() 
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'定投计划',
              content:'定投签约完成',
              dataSouse:[['申请编号',result.content.planId],['产品名称',fundName],['投资金额',this.props.paymentText+'元']],
              souseVal:['返回智投首页']
            }
          });
      } else if (i===0) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'定投计划',
              content:'定投签约失败',
              content2:result,
              dataSouse:[],
              souseVal:['返回智投首页','联系客服']
            }
          });
      }else{
        hashHistory.push({
          pathname:'/ErrorResult',
          state: {
            title:'定投计划',
            content:'结果未知',
            content2:'申请结果未知，请等待日终状态后联系客服',
            dataSouse:[],
            souseVal:['返回华夏智投','联系客服']
          }
        });
    }
    }

      if (payInfoData.currentType==1) {
        let itemCard=payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        if(itemCard.yhkBool){
          let data={
            password:Util.encrypt(this.props.keyPasswordVal),
            fundCode:fundCode,
            paymentChannelId:itemCard.paymentChannelId,
            periodTradeType:0,
            periodType:this.state.pickerValue[0],
            tradeDays:this.state.pickerValue[1],
            tradeAmount:this.props.paymentText,
            bankAccountShowNo:itemCard.bankAccountShowNo,
            bankCode:itemCard.bankCode
          }
          dispatch(createBuyPlanzxk(data,pushResult))
        }else{
          let data={
            password:Util.encrypt(this.props.keyPasswordVal),
            fundCode:fundCode,
            paymentAccountId:itemCard.paymentAccountId,
            periodType:this.state.pickerValue[0],
            tradeDays:this.state.pickerValue[1],
            tradeAmount:this.props.paymentText,
          }
          dispatch(createBuyPlan(data,pushResult))
        }
        
      }else if (payInfoData.currentType==2) {
        let itemCard=payInfoData.content.shareList[payInfoData.currentIndex];
        let data={
        password:Util.encrypt(this.props.keyPasswordVal),
        fundCode:fundCode,
        paymentChannelId:itemCard.paymentChannel,
        periodTradeType:0,
        periodType:this.state.pickerValue[0],
        tradeDays:this.state.pickerValue[1],
        tradeAmount:this.props.paymentText,
        bankCode:itemCard.bankCode
        }
        dispatch(createPlan(data,pushResult))
      }else if (payInfoData.currentType==3) {
        let itemCard=payInfoData.content.currencyFund[payInfoData.currentIndex];
        let data={
          password:Util.encrypt(this.props.keyPasswordVal),
          fundCode:itemCard.fundCode,
          targetFundCode:fundCode,
          trustChannelId:itemCard.trustChannelId,
          periodType:this.state.pickerValue[0],
          tradeDates:this.state.pickerValue[1],
          tradeAmount:this.props.paymentText,
          bankCode:itemCard.bankCode,
          bankAccountShowNo:itemCard.bankAccountShowNo,
        }
        dispatch(dttByMoneyFundValidate(data,dttByMoneyFundSubmit(data,pushResult)))
      }
    
  }
  //各种限额提示
  maxTipFun = (text, i, type, amount, amountMax) => {
    this.setState({
      tipByMax: ""
    });
    if(text === null || text === "" || text === undefined) {
      return;
    }
    let yhkList = this.props.payInfoData.content.currentAccountList;
    let hqtList = this.props.payInfoData.content.shareList;
    let lqbList = this.props.payInfoData.content.currencyFund;
    let _amount = amount === null || amount === "" || amount === undefined ? null : Number(amount);
    let _amountMax = amountMax === null || amountMax === "" || amountMax === undefined ? null : Number(amountMax);
    let _index = i;
    let _type = type;
    if(text === 0 || text === "0") {
      this.setState({
        tipByMax: "申购金额不能为0"
      });
      return;
    }
    if(_amount !== null && _amount !== "" && _amount !== undefined) {
      if(text < _amount) {
        this.setState({
          tipByMax: "申购金额低于最低限额"
        });
        return;
      }
    }
    if(_amountMax !== null && _amountMax !== "" && _amountMax !== undefined) {
      if(text > _amountMax) {
        this.setState({
          tipByMax: "申购金额超过最高限额"
        });
        return;
      }
    }
    if(_type == "1") {
      if(yhkList && yhkList.length > 0) {
        if(yhkList[_index].tradeMaxAmountTips.indexOf("|") != -1) {
          let _num = yhkList[_index].tradeMaxAmountTips.split("|")[0];
          _num = _num >= 0 ? Number(_num) : _num;
          if(_num !== null && _num !== "" && _num !== undefined) {
            if(text > _num) {
              this.setState({
                tipByMax: "申购金额超过银行卡限额"
              });
            }
          }
        }
      }
    }else if(_type == "2") {
      if(hqtList && hqtList.length > 0) {
        if(hqtList[_index].availableVolume !== null && hqtList[_index].availableVolume !== "" && hqtList[_index].availableVolume !== undefined) {
          if(text > hqtList[_index].availableVolume) {
            this.setState({
              tipByMax: "申购金额超过可用余额"
            });
          }
        }
      }
    }else if(_type == "3") {
      if(lqbList && lqbList.length > 0) {
        if(lqbList[_index].availableVolume !== null && lqbList[_index].availableVolume !== "" && lqbList[_index].availableVolume !== undefined) {
          if(text > lqbList[_index].availableVolume) {
            this.setState({
              tipByMax: "申购金额超过可用余额"
            });
          }
        }
      }
    }
  }
  resetRiskFun = () => {
    this.setState({
      showRiskModal: false
    });
    goPubQuestionnaires(hashHistory, window.history.length, ()=>{
      this.next("1");
    });
    return;
  }
  sameDataFun = () => {
    this.setState({
      showRiskModal: false
    });
    this.props.dispatch(syncCwimRiskToCamcAndStopOutOfRiskBuyPlan({}, () => {
      this.next("2");
    }));
    return;
  }
  riskShowFun = () => {
    this.setState({
      showRiskModal: true
    });
  }
  paymentMethod = () => {
    hashHistory.push({
      pathname: '/PayCardList',
      state:{
        type: 'superFundDT',
        actionType: 'SUPER_FUND_DT',
        fundCode: this.props.fundCode
      }
    });
  }
  render(){
    console.log(this.props.payInfoData,"94949949494")
    const img_arr = [require('../../../img/square.png'),require('../../../img/protocol_selected.png')];
    let {payInfoData}=this.props;
    let {titleHeader,fundName,fundCode}=this.props
    return (
        <div className="container">
          {/*头部*/}
          <div style={{marginTop: -10}}>
            <div style={{paddingTop: 20, paddingBottom: 20, paddingLeft: 20, paddingRight: 20, width: window.winWidth,display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", height: 62,backgroundColor: "#fff", borderTopLeftRadius: 10, borderTopRightRadius: 10}}>
              <span style={{fontSize:16,color:'#333',fontWeight: "500"}}>{this.props.fundName+'('+this.props.fundCode+')'}</span>
            </div>
            <div style={{marginTop: 10, paddingTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 20, backgroundColor: "#fff", paddingRight: 20}}>
              <span style={{fontSize:16,color:'#333',fontWeight: "500"}}>每期定投金额</span>
              {
                this.props.paymentText == '' ?
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 15}}>
                  <span style={{color:'#999',fontSize:12}}>|</span>
                  <span style={{color:'#F8515C',fontSize:12, marginTop: 1, marginLeft: 2}}>{"请输入申购金额"}</span>
                </div>
                :
                null
              }
              {
                this.state.tipByMax ?
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 15}}>
                  <span style={{color:'#999',fontSize:12}}>|</span>
                  <span style={{color:'#F8515C',fontSize:12, marginTop: 1, marginLeft: 2}}>{this.state.tipByMax}</span>
                </div>
                :
                null
              }
            </div>
            {
              this.state.popoverCountFlag ?
              <div style={{backgroundColor: "#fff", display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 60, height: 20}}>
                <span style={{color:'#999',fontSize:12}}>|</span>
                <span style={{color:'#999',fontSize:12, marginTop: 1, marginLeft: 2}}>{this.state.popoverCount}</span>
              </div>
              :
              <div style={{height: 20, backgroundColor: "#fff"}}></div>
            }
            <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center",paddingLeft: 20, paddingRight: 20,backgroundColor: "#fff"}}>
              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingBottom: 9.5, borderBottomColor: "#EBEBEB", borderBottomWidth: 0.5, borderBottomStyle: "solid", width: window.winWidth - 40}}>
                <span style={{fontSize:24,fontWeight: "500", color: "#333"}}>¥</span>
                <input className='price_placeholder_style' style={{fontSize: 24, color: "#333", fontWeight: "400", marginLeft: 10, width: 240}} autoComplete="off" value={this.props.paymentText}  placeholder={`${Util.parsePrice(this.state.amount)}元起购`}  onChange={(e)=>this.onChangeText(e.target.value)} type="text"  />
              </div>
            </div>
            <div style={{paddingTop: 14.5, paddingBottom: 14.5, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", backgroundColor: "#fff", paddingLeft: 20}}>
              <span style={{color: "#999", fontSize: 12}}>基金申购费率：</span>
              <span style={{fontSize:12,color:'#B69271', fontWeight: "500"}}>0-1折</span>
            </div>
            <div style={{marginTop: 10}}>
              <Picker
                title="选择定投周期"
                extra={this.state.pickerValue}
                cols={2}
                data={this.state.dataSouse}
                value={this.state.pickerValue}
                onChange={v => {console.log(v);this.setState({ pickerValue: v })}}
              >
                <CustomChildren style={{fontSize: 13, color: "#3a3f47"}}>定投时间</CustomChildren>
              </Picker>
            </div>
            <div style={{width: window.winWidth, paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff"}}>
              <div style={{height: 0.5, backgroundColor: "#EBEBEB", width: window.winWidth - 40}}></div>
            </div>
            {/*支付方式*/}
            <div style={{paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff"}}>
              <PayCardSuperFund type='superFundDT' superFundCode={this.props.fundCode} actionType='SUPER_FUND_DT'/>
            </div>
            <div>
            {/* style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 15, paddingRight: 25, width: window.winWidth}} */}
              <div style={{height: "auto", paddingTop: 10, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}} className='pay-agree'>
                <img src={img_arr[this.props.smSzt]} style={{width: 32, height: 32}} onClick={()=>this.isAgreeClick()}/>
                <p style={{display:'block'}}><span style={{color:'#999999',fontSize:12}}>我已阅读并同意</span>
                  <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('华夏查理智投定期定额申请协议')}>《华夏查理智投定期定额申请协议》</span>
                  {
                    this.props.fundCode == 'SF1012'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-货币')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1015'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-固收')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1016'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-权益')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1014'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-指数')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1017' || this.props.fundCode == 'SF1018'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-教育')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1019' || this.props.fundCode == 'SF1020' || this.props.fundCode == 'SF1021' || this.props.fundCode == 'SF1013'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-养老')}>《投资组合策略说明书》</span>
                    :
                    this.props.policy && this.props.policyTitle?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper(this.props.policyTitle ? this.props.policyTitle : "")}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1036'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-工资宝')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1038'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-7分小进取')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1039'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-指数增强')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1060'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-安心宝')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1067'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-价值精选')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1022'?
                    <span style={{color: "#5270A3"}}  onClick={()=>this.ProtocolPaper('投资组合策略说明书-货币增强')}>《投资组合策略说明书》</span>
                    :
                    null
                  }
                  <span style={{color:'#999999',fontSize:12}}>及特别提示内容</span>
                </p>
              </div>
              <div style={{width: window.winWidth, paddingLeft: 20, paddingRight: 20, marginTop: 20}}>
                {
                  this.props.smSzt==1&&Util.regular1.test(this.props.paymentText) ? 
                  <div onClick={()=>this.next()} style={{width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#fa063a", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                    <span style={{fontSize: 16, color: "#fff"}}>下一步</span>
                  </div>
                  :
                  <div style={{width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#D3D4D6", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                    <span style={{fontSize: 16, color: "#fff"}}>下一步</span>
                  </div>
                }
              </div>
              <div style={{marginTop:20, paddingLeft: 7, paddingRight: 7}}><PayWarmTips buyType='SF' fundLimit={this.props.fundLimit}/></div>
            </div>
          </div>
          {
            this.state.showRiskModal ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>活期通、闪购相关服务由华夏基金提供，根据华夏基金的评分标准，您的风险承受能力为：C1保守型。</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>根据《证券期货投资者适当性管理办法》的规定，您适合交易风险等级为R1的产品。<span style={{fontSize: 15, color: "#333", lineHeight: "20px", fontWeight: "bold"}}>您如果确定认同此风险等级评定，为了降低您的风险，我们将终止您在华夏基金已经签约的R1产品以外的计划类交易，包括定投、智能认购、定期转换等。</span></p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.resetRiskFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>重新测评</p>
                  </div>
                  <div onClick={this.sameDataFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>确认</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {
            this.state.unionPayTransformBool ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>财富卡支付方式金额不得超过5000元，请您选择其他支付方式或下载华夏财富app操作</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.paymentMethod} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>修改支付方式</p>
                  </div>
                  <div onClick={()=>{this.setState({unionPayTransformBool: false})}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>确认</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    payInfoData:state.superFundDTPayInfo,
    paymentText:state.paymentTextDT,
    findHqtExist:state.findHqtExist,
    smSzt:state.smSzt,
  }
}
export default connect(mapStateToProps)(FixedInvestmentSuperFund);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/FixedInvestmentSuperFund.js